import React from 'react';
import { purgeMsalStorage } from '../auth/msalConfig';

/**
 * App-wide safety net. Without this, any render-time throw (or a downstream
 * auth/render failure) unmounts the tree to a blank white page with no way to
 * recover. Here we catch it, show a friendly screen, and give the user a
 * "Reload" action that also clears any stale MSAL interaction state — the most
 * common cause of the "white page after inactivity" symptom.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface the stack for diagnostics; real telemetry wiring rides with M1.
    console.error('Unhandled UI error caught by ErrorBoundary', error, info);
  }

  handleReload = () => {
    // Purge all MSAL state from both stores so the next boot starts from a clean
    // cache instead of choking on the same corrupt/stale entry again.
    purgeMsalStorage();
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 14,
        color: '#0D1B2A', fontFamily: 'system-ui, sans-serif', padding: 24, textAlign: 'center',
      }}>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Something went wrong</div>
        <div style={{ fontSize: 13, color: '#7A8899', maxWidth: 420, lineHeight: 1.6 }}>
          Your session may have expired while the app was idle. Reloading will sign
          you back in and restore the page.
        </div>
        <button
          onClick={this.handleReload}
          style={{
            marginTop: 4, padding: '8px 18px', borderRadius: 8, border: 'none',
            background: '#1565C0', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
